/* ================================================================
   LegBilligt — LEGETOEJSAUTOMATEN
   Et rigtigt automatskab: buet topskilt med vores logo, kromramme
   om de tre ruller, haandtag i siden og en udleveringsbakke
   nederst hvor "Laeg alle tre i kurv" ligger.

   AUTOMATEN VISER KUN DEN KATEGORI MAN STAAR PAA. Handlen kommer
   fra data-h paa elementet, som Liquid saetter til
   collection.handle, saa paa /collections/legetoej kan der kun
   komme legetoej i rullerne. Og den viser kun varer der er paa
   lager - men det er ligegyldigt, om de staar paa vores eget lager
   eller paa fjernlager: paa en kategoriside skal kunden se
   kategorien, ikke vores lagerregnskab. Jakob, 18. september 2026.

   KILDEN ER ?view=lager OG IKKE products.json (18-09).
   products.json ignorerer sidens filter og svarede i kollektionens
   egen BEST_SELLING-sortering, og med 0 ordrer i Shopify laa de
   udsolgte forrest: side 1 af /collections/legetoej havde 0
   koebbare varer ud af 250, mens gitteret paa siden - som bruger
   Shopifys eget availability-filter - viste 1.891 koebbare varer.
   Derfor stod der "Automaten holder pause lige nu" paa en side, der
   var fuld af varer. ?view=lager filtrerer paa serveren FOER
   sideopdelingen, saa hver side er fuld af varer man kan koebe.

   Puljen deles med lb-top.js gennem window.__lbPuljer, saa siden
   kun henter foerste side EN gang. De to filer SKAL derfor hente
   fra samme adresse. Top 10 bruger de ti foerste i den raekkefoelge
   de kommer, saa automaten laegger altid sine ekstra sider BAGEST
   og roerer ikke de foerste ti.

   Kun varer med EN variant kommer i automaten — ellers kan
   "Laeg alle tre i kurv" ikke holde hvad den lover. Er der for faa
   af dem, falder vi tilbage til hele puljen.

   TO MAADER AT KOEBE PAA. Bundlen alene var alt eller intet, og de
   fleste kunder kan kun lide en af de tre. Derfor har hver vare nu
   sin egen kurvknap under prisen, og bundlen bliver staaende i
   bakken. Begge veje gaar gennem den samme iKurv().
   "Behold" flyttede samtidig op i hjornet af billedet: den er en
   spilleknap, ikke en koebsknap, og skulle vaek fra den spalte hvor
   pris og kurvknap staar. Knapperne pr. vare slaas fra mens
   rullerne drejer — varen under en rulle der koerer findes ikke endnu.

   TO REGLER DER GOER SPINNET GODT
   ------------------------------------------------------------
   1. BLANDING: de tre varer maa ikke komme fra samme
      underkategori. Alle varer baerer et k2-tag (k2-bamser,
      k2-konstruktion, k2-legetoejsvaaben ...), saa det koster
      ingen ekstra hentning - ?view=lager har tags med, praecis
      som products.json havde. Reglen fanger tre bamser i traek,
      tre vaerktoej i traek og tre vaaben i traek paa en gang.
      Kan puljen ikke levere tre forskellige, fylder vi op med
      hvad der er — bedre en gentagelse end en tom rulle.

   2. DYBDE: Legetoej har ca. 1.900 koebbare varer, men en side
      giver 50 ad gangen. Var automaten laast til de foerste 50,
      begyndte varerne at gaa igen efter faa traek. Nu henter den
      en tilfaeldig ANDEN side ind i baggrunden - foerste gang
      lige efter de tre foerste er paa plads, og derefter efter
      hvert traek. Jo mere kunden leger med den, jo dybere graver
      den. Loftet er ikke gaettet mere: ?view=lager svarer med
      "sider", saa den kender kollektionens stoerrelse med det
      samme. Max 12 ekstra sider pr. sidevisning, saa den ikke
      loeber loebsk hvis nogen spammer haandtaget.

   Provet og kasseret: at filtrere legetoejsvaaben og blasters HELT
   ud af puljen. De udgor ca. 11 % af varerne, hvilket giver to
   vaaben i samme spin ca. hver 30. gang og tre ca. hver 800. gang.
   At skaere en hel underkategori vaek af sortimentet for at undgaa
   noget der sker 3 % af tiden er den forkerte pris. Regel 1
   ovenfor loser det samme problem uden at skjule varer.

   FOERPRIS (Jakob 27-10, Black Month-forsiden): "den skal ogsaa vise
   tilbud priserne". ?view=lager sender nu ogsaa variantens
   compare_at_price med. Den vises KUN naar elementet har
   data-foer="1" (det har automaten paa forsiden, lb-bf-automat), og
   kun naar foerprisen er hoejere end prisen. Kategorisiderne har ikke
   data-foer og ser ud som foer. Bundlen i bakken viser paa samme
   maade de tre foerpriser lagt sammen (pris for varer uden foerpris).

   Billedbredde 380 (samme som lb-top.js, saa cachen passer).
   Ingen MutationObserver.
   ================================================================ */
(function(){
  'use strict';

  var K = 'lb_onsker';
  var BRED = 380;
  var VENT = 700;
  var MINPULJE = 12;
  var FORFYLD = 14;                 /* billeder der ruller forbi i en rulle */
  var MAXEKSTRA = 12;               /* hvor mange ekstra sider vi hoejst henter */
  var MS = [900, 1150, 1420];       /* rullerne stopper efter hinanden */
  var HJERTE = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 20.5S3.5 15 3.5 9.2A4.7 4.7 0 0 1 12 6.4a4.7 4.7 0 0 1 8.5 2.8c0 5.8-8.5 11.3-8.5 11.3z"/></svg>';
  var LAAS = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M7 10V8a5 5 0 0 1 10 0v2h1a1 1 0 0 1 1 1v9a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1v-9a1 1 0 0 1 1-1h1zm2 0h6V8a3 3 0 0 0-6 0v2z"/></svg>';

  var ARM = '<svg class="lbau-svg" viewBox="0 0 40 150" aria-hidden="true" preserveAspectRatio="xMidYMax meet">' +
    '<defs>' +
      '<linearGradient id="lbauStang" x1="0" y1="0" x2="1" y2="0">' +
        '<stop offset="0" stop-color="#535B69"/><stop offset=".16" stop-color="#A7B1C1"/>' +
        '<stop offset=".36" stop-color="#F6F9FD"/><stop offset=".54" stop-color="#C3CCDA"/>' +
        '<stop offset=".78" stop-color="#788294"/><stop offset="1" stop-color="#464D5A"/>' +
      '</linearGradient>' +
      '<linearGradient id="lbauKrave" x1="0" y1="0" x2="1" y2="0">' +
        '<stop offset="0" stop-color="#464D5A"/><stop offset=".32" stop-color="#EDF1F7"/>' +
        '<stop offset=".62" stop-color="#A3ADBC"/><stop offset="1" stop-color="#3E4451"/>' +
      '</linearGradient>' +
      '<radialGradient id="lbauKugle" cx=".33" cy=".27" r=".82">' +
        '<stop offset="0" stop-color="#FF8578"/><stop offset=".26" stop-color="#E14C40"/>' +
        '<stop offset=".64" stop-color="#B22A22"/><stop offset="1" stop-color="#6B1610"/>' +
      '</radialGradient>' +
    '</defs>' +
    '<rect x="15" y="24" width="10" height="120" rx="5" fill="url(#lbauStang)"/>' +
    '<rect x="17.3" y="29" width="1.8" height="110" rx=".9" fill="#fff" opacity=".5"/>' +
    '<rect x="10.5" y="112" width="19" height="13" rx="4" fill="url(#lbauKrave)"/>' +
    '<rect x="10.5" y="112" width="19" height="3" rx="1.5" fill="#fff" opacity=".35"/>' +
    '<circle cx="20" cy="20" r="19" fill="url(#lbauKugle)"/>' +
    '<path d="M2.4 24a17.6 17.6 0 0 0 35.2 0 19 19 0 0 1-35.2 0z" fill="#FF9C90" opacity=".3"/>' +
    '<ellipse cx="13.2" cy="11.6" rx="6.6" ry="4.4" fill="#fff" opacity=".6" transform="rotate(-30 13.2 11.6)"/>' +
    '<ellipse cx="26.5" cy="29.5" rx="3.4" ry="2" fill="#fff" opacity=".16"/>' +
  '</svg>';

  var puljer = (window.__lbPuljer = window.__lbPuljer || {});
  var henter = (window.__lbHenter = window.__lbHenter || {});
  /* window.__lbSider er et TAL pr. handle: hvor mange sider
     kollektionen har. Det deles med lb-top.js. Hvilke sider VI har
     hentet er derimod kun automatens eget regnskab og bliver holdt
     her i filen - de to maa ikke ligge i samme kasse. */
  var sider = (window.__lbSider = window.__lbSider || {});
  var stand = {};

  function laes(){ try { return JSON.parse(localStorage.getItem(K)) || []; } catch(e){ return []; } }
  function paaSedlen(h){ return laes().indexOf(h) > -1; }
  function kr(n){ return n.toFixed(2).replace('.', ',') + ' kr'; }

  /* ?view=lager leverer billedet med en bredde paa (width=640), hvor
     products.json leverede det uden. Saetter vi bare endnu et width=
     paa, staar der to i samme adresse, og CDN'et har ingen grund til
     at vaelge vores. Derfor rettes den der er, og ellers saettes en. */
  function lille(src, b){
    if(!src) return '';
    if(/[?&]width=\d+/.test(src)) return src.replace(/([?&]width=)\d+/, '$1' + b);
    return src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=' + b;
  }

  /* underkategorien ligger i varens k2-tag */
  function k2af(p){
    var t = p.tags || [], i;
    for(i = 0; i < t.length; i++){
      if(String(t[i]).indexOf('k2-') === 0) return t[i];
    }
    return '';
  }

  function normaliser(p){
    var v = null, i;
    for(i = 0; i < p.variants.length; i++){
      if(p.variants[i].available){ v = p.variants[i]; break; }
    }
    if(!v) return null;
    var pris = parseFloat(v.price);
    if(!(pris > 0)) return null;
    var foer = parseFloat(v.compare_at_price) || 0;
    var raa = (p.images && p.images[0]) ? p.images[0].src : '';
    if(!raa) return null;
    return { id: v.id, handle: p.handle, titel: p.title,
             url: '/products/' + p.handle, pris: pris,
             foer: foer > pris ? foer : 0,
             bil: lille(raa, BRED), flere: p.variants.length > 1,
             k2: k2af(p) };
  }

  function hentSide(h, nr){
    return fetch('/collections/' + h + '?view=lager&filter.v.availability=1&page=' + nr)
      .then(function(r){ return r.ok ? r.json() : {products:[]}; })
      .catch(function(){ return {products:[]}; });
  }

  function hentPulje(handle){
    if(puljer[handle]) return Promise.resolve(puljer[handle]);
    if(henter[handle]) return henter[handle];
    henter[handle] = hentSide(handle, 1).then(function(d){
      var ud = [];
      (d.products || []).forEach(function(p){
        var n = normaliser(p);
        if(n) ud.push(n);
      });
      if(d.sider) sider[handle] = d.sider;
      puljer[handle] = ud;
      return ud;
    });
    return henter[handle];
  }

  /* ---- dybere ned i sortimentet --------------------------------
     Henter en tilfaeldig side vi ikke har set for. Loftet er ikke
     gaettet: ?view=lager svarer med "sider", saa vi kender antallet
     fra foerste hentning.                                          */
  function sidestand(h){
    if(!stand[h]) stand[h] = { hentet: {1:1}, antal: 0, igang: false };
    return stand[h];
  }

  function dybere(h, naar){
    var s = sidestand(h);
    var loft = sider[h] || 1;
    if(s.igang || s.antal >= MAXEKSTRA || loft < 2) return;

    var frie = [], n;
    for(n = 2; n <= loft; n++){ if(!s.hentet[n]) frie.push(n); }
    if(!frie.length) return;                     /* vi kender hele kollektionen */

    var valg = frie[Math.floor(Math.random() * frie.length)];
    s.hentet[valg] = 1;
    s.igang = true;

    hentSide(h, valg).then(function(d){
      s.igang = false;
      var raa = d.products || [];
      if(!raa.length) return;
      s.antal++;
      var ud = [];
      raa.forEach(function(p){ var v = normaliser(p); if(v) ud.push(v); });
      if(ud.length) naar(ud);
    });
  }

  function bland(a){
    for(var i = a.length - 1; i > 0; i--){
      var j = Math.floor(Math.random() * (i + 1));
      var t = a[i]; a[i] = a[j]; a[j] = t;
    }
    return a;
  }

  function klargoer(varer, naar){
    var mangler = varer.length, kaldt = false;
    function faerdig(){ if(!kaldt){ kaldt = true; naar(); } }
    if(!mangler){ faerdig(); return; }
    setTimeout(faerdig, VENT);
    varer.forEach(function(v){
      var i = new Image();
      i.decoding = 'async';
      i.onload  = function(){ if(--mangler <= 0) faerdig(); };
      i.onerror = function(){ if(--mangler <= 0) faerdig(); };
      i.src = v.bil;
    });
  }

  function opdaterKurvIkon(){
    var boble = document.getElementById('cart-icon-bubble');
    if(!boble) return;
    fetch('/?sections=cart-icon-bubble')
      .then(function(r){ return r.json(); })
      .then(function(d){
        if(!d || !d['cart-icon-bubble']) return;
        var midl = document.createElement('div');
        midl.innerHTML = d['cart-icon-bubble'];
        var nyt = midl.querySelector('#cart-icon-bubble');
        boble.innerHTML = nyt ? nyt.innerHTML : d['cart-icon-bubble'];
      })
      .catch(function(){});
  }

  function skelet(){
    var vind = '', info = '', paerer = '', i;
    for(i = 0; i < 3; i++){
      vind += '<div class="lbau-hul" data-i="' + i + '">' +
                '<a class="lbau-vind" href="#" tabindex="-1" aria-hidden="true"></a>' +
                '<button type="button" class="lbo-hj" data-h="" aria-label="Sæt på ønskesedlen">' + HJERTE + '</button>' +
                '<button type="button" class="lbau-laas" data-i="' + i + '">' + LAAS + '<span>Behold</span></button>' +
              '</div>';
      info += '<div class="lbau-r" data-i="' + i + '">' +
                '<a class="lbau-t" href="#"></a>' +
                '<div class="lbau-pr"></div>' +
                '<button type="button" class="lbau-en" data-i="' + i + '">Læg i kurv</button>' +
              '</div>';
    }
    for(i = 0; i < 9; i++){ paerer += '<i class="lbau-lys"></i>'; }

    return '<div class="lbau-maskine">' +
             '<div class="lbau-skilt">' +
               '<span class="lbau-paerer">' + paerer + '</span>' +
               '<span class="lbau-plade"><span class="lbau-logo" role="img" aria-label="LegBilligt"></span></span>' +
               '<span class="lbau-jack">Automaten</span>' +
             '</div>' +
             '<div class="lbau-krop">' +
               '<div class="lbau-panel"><div class="lbau-vinduer">' + vind + '</div></div>' +
               '<div class="lbau-info">' + info + '</div>' +
               '<div class="lbau-styr">' +
                 '<div class="lbau-knap">' +
                   '<button type="button" class="lbau-spin">Træk i håndtaget</button>' +
                   '<div class="lbau-armhus">' +
                     '<button type="button" class="lbau-arm" aria-label="Træk i håndtaget">' + ARM + '</button>' +
                   '</div>' +
                 '</div>' +
                 '<p class="lbau-tip">Tryk &laquo;Behold&raquo; på den I vil gemme &mdash; så spinner kun de andre.</p>' +
               '</div>' +
             '</div>' +
             '<div class="lbau-fod">' +
               '<div class="lbau-bakke"><div class="lbau-bund"></div></div>' +
             '</div>' +
           '</div>';
  }

  function saet(rod){
    if(rod.dataset.klar) return;
    rod.dataset.klar = '1';

    var H = rod.dataset.h || '';
    /* Navneordet om de tre varer kommer fra Liquid (data-ord), saa
       automaten kan staa paa flere moderkategorier uden at kalde
       perler og malebøger for legetoej. Bruges ét sted: bundlen i
       udleveringsbakken. Underlinjen over maskinen bruger det samme
       ord — de to SKAL matche, ellers lyder siden som to butikker. */
    var ORD = rod.dataset.ord || 'stykker legetøj';
    var VISFOER = rod.dataset.foer === '1';
    var laast = [false, false, false];
    var valgt = [null, null, null];
    var pulje = [], forfyld = [], spinner = false, kunEn = true;

    rod.innerHTML = skelet();
    var huller = rod.querySelectorAll('.lbau-hul');
    var infoer = rod.querySelectorAll('.lbau-r');
    var spinKn = rod.querySelector('.lbau-spin');
    var arm    = rod.querySelector('.lbau-arm');
    var bund   = rod.querySelector('.lbau-bund');

    /* ---------- klik ---------- */
    spinKn.addEventListener('click', spin);
    arm.addEventListener('click', spin);

    rod.addEventListener('click', function(e){
      var b = e.target.closest ? e.target.closest('.lbau-laas') : null;
      if(!b) return;
      e.preventDefault();
      var i = Number(b.dataset.i);
      if(!valgt[i]) return;
      laast[i] = !laast[i];
      b.classList.toggle('paa', laast[i]);
      huller[i].classList.toggle('laast', laast[i]);
      b.querySelector('span').textContent = laast[i] ? 'Beholdt' : 'Behold';
      spinKn.textContent = laast.every(Boolean) ? 'Slip en rulle først' : 'Træk i håndtaget';
      spinKn.disabled = laast.every(Boolean);
    });

    /* Samme vej i kurven for den enkelte vare og for alle tre. */
    function iKurv(b, varer){
      if(!b || b.disabled || !varer.length) return;
      var org = b.dataset.org || b.textContent;
      b.dataset.org = org;
      b.disabled = true;
      b.textContent = 'Lægger i kurv …';
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: varer.map(function(v){ return { id: v.id, quantity: 1 }; }) })
      })
      .then(function(r){ return r.json(); })
      .then(function(svar){
        if(svar && svar.status && svar.status !== 200) throw new Error('fejl');
        opdaterKurvIkon();
        b.textContent = 'Lagt i kurven ✓';
        b.classList.add('ok');
        setTimeout(function(){
          b.textContent = org; b.classList.remove('ok'); b.disabled = false;
        }, 1800);
      })
      .catch(function(){
        b.textContent = 'Prøv igen';
        setTimeout(function(){ b.textContent = org; b.disabled = false; }, 1800);
      });
    }

    rod.addEventListener('click', function(e){
      if(!e.target.closest) return;
      var alle = e.target.closest('.lbau-alle');
      if(alle){ e.preventDefault(); iKurv(alle, valgt.filter(Boolean)); return; }
      var en = e.target.closest('.lbau-en');
      if(en){
        e.preventDefault();
        var v = valgt[Number(en.dataset.i)];
        if(v) iKurv(en, [v]);
      }
    });

    /* ---------- tegning ---------- */
    function saetRulle(i, v){
      var hul  = huller[i];
      var vind = hul.querySelector('.lbau-vind');
      var hj   = hul.querySelector('.lbo-hj');
      var t    = infoer[i].querySelector('.lbau-t');
      var pr   = infoer[i].querySelector('.lbau-pr');
      vind.innerHTML = '<span class="lbau-bil" style="background-image:url(\'' + v.bil + '\')"></span>';
      vind.setAttribute('href', v.url);
      vind.removeAttribute('aria-hidden');
      vind.removeAttribute('tabindex');
      t.setAttribute('href', v.url);
      t.textContent = v.titel;
      if(VISFOER && v.foer > v.pris){
        pr.innerHTML = kr(v.pris) + ' <s><span class="visually-hidden">Før </span>' + kr(v.foer) + '</s>';
      } else {
        pr.textContent = kr(v.pris);
      }
      hj.dataset.h = v.handle;
      hj.classList.toggle('paa', paaSedlen(v.handle));
      hul.classList.remove('pop');
      void hul.offsetWidth;
      hul.classList.add('pop');
      valgt[i] = v;
    }

    function drej(i, ny, ms, naar){
      var vind = huller[i].querySelector('.lbau-vind');
      var h = vind.clientHeight || 150;
      var raekke = bland(forfyld.slice(0)).slice(0, 7);
      raekke.push(ny);
      var s = '<div class="lbau-strip">';
      raekke.forEach(function(p){
        s += '<span style="height:' + h + 'px;background-image:url(\'' + p.bil + '\')"></span>';
      });
      s += '</div>';
      vind.innerHTML = s;
      var strip = vind.firstChild;
      strip.style.transform = 'translateY(0)';
      void strip.offsetHeight;
      strip.style.transition = 'transform ' + ms + 'ms cubic-bezier(.16,.86,.28,1)';
      strip.style.transform = 'translateY(' + (-(raekke.length - 1) * h) + 'px)';
      setTimeout(function(){ saetRulle(i, ny); naar(); }, ms + 70);
    }

    function opdaterBund(){
      var varer = valgt.filter(Boolean);
      if(varer.length < 3){ bund.innerHTML = ''; return; }
      var sum = 0, sumFoer = 0;
      varer.forEach(function(v){ sum += v.pris; sumFoer += (v.foer > v.pris ? v.foer : v.pris); });
      var foerTxt = (VISFOER && sumFoer > sum + 0.005)
        ? '<s><span class="visually-hidden">Før </span>' + kr(sumFoer) + '</s>' : '';
      bund.innerHTML =
        '<div class="lbau-sum"><span>Tre ' + ORD + '</span><b>' + kr(sum) + '</b>' + foerTxt + '</div>' +
        '<button type="button" class="lbau-alle">Læg alle tre i kurv</button>';
    }

    /* Traekker "antal" varer der hverken gentager en vare eller en
       underkategori fra "undtag". Kan puljen ikke levere nok
       forskellige, fylder vi op med resten.                        */
    function nye(antal, undtag){
      var brugt = {}, grupper = {};
      undtag.forEach(function(v){
        if(!v) return;
        brugt[v.handle] = 1;
        if(v.k2) grupper[v.k2] = 1;
      });

      var kan = bland(pulje.slice(0)).filter(function(v){ return !brugt[v.handle]; });
      var ud = [], rest = [], i, g;

      for(i = 0; i < kan.length && ud.length < antal; i++){
        g = kan[i].k2;
        if(g && grupper[g]){ rest.push(kan[i]); continue; }
        if(g) grupper[g] = 1;
        ud.push(kan[i]);
      }
      for(i = 0; i < rest.length && ud.length < antal; i++){ ud.push(rest[i]); }
      return ud;
    }

    /* Lægger en tilfaeldig ny side af sortimentet oven i puljen.
       BAGEST, aldrig forrest: Top 10 laeser de foerste ti fra samme
       pulje, og den raekkefoelge er salgsdata. */
    function udvidPulje(){
      dybere(H, function(friske){
        var kendt = {};
        pulje.forEach(function(v){ kendt[v.handle] = 1; });
        var tilfoejet = 0;
        friske.forEach(function(v){
          if(kendt[v.handle]) return;
          if(kunEn && v.flere) return;
          pulje.push(v);
          tilfoejet++;
        });
        if(!tilfoejet) return;
        /* nye billeder ind i rullerne, saa de ogsaa foles friske */
        forfyld = bland(pulje.slice(0)).slice(0, FORFYLD);
        forfyld.forEach(function(v){ var b = new Image(); b.decoding = 'async'; b.src = v.bil; });
      });
    }

    function spin(){
      if(spinner || pulje.length < 6) return;
      var ledige = [0,1,2].filter(function(i){ return !laast[i]; });
      if(!ledige.length) return;

      spinner = true;
      rod.classList.add('kor');
      spinKn.disabled = true;
      spinKn.textContent = 'Spinner …';
      arm.classList.add('trukket');
      bund.innerHTML = '';
      /* varen under en rulle der drejer findes ikke endnu */
      rod.querySelectorAll('.lbau-en').forEach(function(k){ k.disabled = true; });

      var behold = valgt.filter(function(v, i){ return laast[i]; });
      var friske = nye(ledige.length, behold);
      if(friske.length < ledige.length){ friske = nye(ledige.length, []); }

      klargoer(friske, function(){
        var tilbage = ledige.length;
        ledige.forEach(function(i, n){
          drej(i, friske[n], MS[n] || MS[MS.length - 1], function(){
            if(--tilbage > 0) return;
            spinner = false;
            rod.classList.remove('kor');
            arm.classList.remove('trukket');
            spinKn.disabled = false;
            spinKn.textContent = 'Spin igen';
            rod.querySelectorAll('.lbau-en').forEach(function(k){ k.disabled = false; });
            opdaterBund();
            if(window.lbKortHjerter) window.lbKortHjerter();
            udvidPulje();          /* graver dybere til naeste traek */
          });
        });
      });
    }

    /* ---------- start ---------- */
    rod.classList.add('kor');
    hentPulje(H).then(function(alle){
      var ren = alle.filter(function(v){ return !v.flere; });
      kunEn = ren.length >= MINPULJE;
      pulje = kunEn ? ren : alle.slice(0);
      rod.classList.remove('kor');
      if(pulje.length < 6){
        rod.innerHTML = '<p class="lbau-tom">Automaten holder pause lige nu.</p>';
        return;
      }
      forfyld = bland(pulje.slice(0)).slice(0, FORFYLD);
      forfyld.forEach(function(v){ var i = new Image(); i.decoding = 'async'; i.src = v.bil; });
      var tre = nye(3, []);
      klargoer(tre, function(){
        tre.forEach(function(v, i){ saetRulle(i, v); });
        opdaterBund();
        if(window.lbKortHjerter) window.lbKortHjerter();
        /* En side er 50 varer. Der hentes én mere med det samme, saa
           det foerste traek ikke kun kan vaelge blandt de 50. */
        udvidPulje();
      });
    });
  }

  function start(){ document.querySelectorAll('.lbau').forEach(saet); }

  if(document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
  document.addEventListener('shopify:section:load', start);
})();